import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=2e988fea&scoped=true&"
import script from "@/scripts/Mall/Order/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/Order/index.js?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=2e988fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e988fea",
  null
  
)

export default component.exports